module.exports = __webpack_public_path__ + "img/error_logo.bad65b98.svg";